import { isBrowser } from './is-browser';

type ICheckLinkSpecialCase = (url: string) => boolean;

export const checkLinkSpecialCase: ICheckLinkSpecialCase = (url) =>
  isBrowser()
    ? window.location.pathname !== url.split('#')[0] &&
      Boolean(url.split('#')[1])
    : false;
